import router from './router'
import noticeMessages from './localization/index'

export default {
  router,
  localization: noticeMessages,
}
